<template>
    <section class="four-zero-four">
        <div class="four-zero-four-container">
            <div class="error-code">403</div>
            <div class="error-message">{{$t('lisa_web_you_can_not_access_this_page')}}</div>
        </div>
    </section>
</template>

<script>
    export default {
        created() {
            //this.$store.commit('SET_LAYOUT', 'simple-layout')
        }

    }
</script>

<style scoped>

</style>